export enum GtmItemCategory {
    Mtpl = 'mtpl',
    Casco = 'casco',
    CascoMtpl = 'casco_mtpl',
    Rider = 'rider',
    TransportInsurance = 'transport_insurance',
}
